module.exports={"nav.dashboard":"Dashboard","nav.stock":"Stock","nav.data":"Data","nav.price":"Price","nav.contact":"Contact"};